import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'

export const ToastNotification = ({ show, message, onClose }) => {
	return (
		<ToastContainer style={{ top: '1rem', right: '1rem', position: 'fixed', zIndex: 9999 }} className="p-3">
			<Toast show={show} onClose={onClose} delay={3000} autohide>
				<Toast.Header>
					<strong className="me-auto">Notification</strong>
				</Toast.Header>
				<Toast.Body>{message}</Toast.Body>
			</Toast>
		</ToastContainer>
	)
}

export const OverviewTextarea = ({ value, onChange, rows = 6, isStudent = false, className = '' }) => {
	if (isStudent) {
		return <div className={`bg-light border rounded p-2 flex-grow-1 overflow-auto ${className}`}>{value}</div>
	}

	return (
		<textarea
			rows={rows}
			className={`form-control flex-grow-1 ${className}`}
			style={{ resize: 'none' }}
			value={value || ''}
			onChange={(e) => onChange(e.target.value)}
		/>
	)
}

export const UpdateButton = ({ onClick, isStudent = false, className = '' }) => {
	if (isStudent) return null

	return (
		<div className={`text-end ${className}`}>
			<button className="btn btn-primary" onClick={onClick}>
				Update
			</button>
		</div>
	)
}

export const ReportCard = ({ title, children, className = '' }) => {
	return (
		<div className={`card p-3 ${className}`}>
			<div className="personal-info-head">
				<h4>{title}</h4>
			</div>
			{children}
		</div>
	)
}
